import React from "react";
import { Button } from "react-bootstrap";

export const FILM_CONFIG = {
  workshopType: 'film',
  heading: 'AI Film Studio',
  subtitle: 'Artificial Intelligence Workshop',
  brand: 'STAGE ONE EDUCATION',
  slideshowUrl: '/ai-film-slideshow',
  footerBlurb: 'Film posters were created by participants using leading AI models',
  nodePageClass: 'intro-page-background',

  storageKeys: {
    node: 'film-nn-node',
    workshopId: 'film-workshop-id',
    password: 'film-frontend-password',
    gptMessages: 'film-gpt-messages',
    dalleOutputs: 'film-dalle-outputs',
    musicgenUrls: 'film-musicgen-urls',
    slide: 'film-slide',
    readyForPoster: 'film-ready-for-poster',
    imageGenerationStarted: 'film-image-generation-started',
    voices: 'film-voices',
    synth: 'film-synth',
  },

  tabs: {
    poster: 'Film Poster',
  },

  gpt: {
    instructionTitle: 'Follow the prompt templates to bring your film to life with AI.',
    instructionSubtitle: 'Remember: apply prompt engineering to enhance and personalize the templates.',
    filmIdeaPrompt1: "List 5 ideas for a short film about ",
    filmIdeaPrompt2: ". Include character development and explain why the film is different from the tropes of the genre.",
    filmIdeas: [
      "dragons and dwarfs: mountain siege",
      "mars colony: rebel uprising",
      "love letters across time",
      "haunted lighthouse: island mystery",
      "mismatched roommates: hilarious chaos",
      "heist at the cyberbank",
      "family secrets: ancestral home",
      "whispering shadows: unsolved crimes",
      "jungle quest for lost city",
      "revolution: the untold story",
      "time loop in ancient rome",
      "virtual world escape",
      "undercover in 1920s paris",
      "alien artifact discovery",
      "pirates of the forgotten seas",
      "cyberpunk city rebellion",
      "haunted victorian mansion",
      "wild west robot showdown",
      "post-apocalyptic road journey",
      "deep sea alien encounter",
      "medieval kingdom betrayal",
      "lost in a digital universe",
      "celebrity life undercover",
      "arctic expedition survival",
      "ancient egyptian curse",
      "parallel lives intersect",
      "desert oasis mirage",
      "robotic uprising in 2077",
      "summer camp secrets",
      "moon colony conspiracy",
    ],
    getPrompts: ({ handlePromptButtonClicked, setActiveTab }) => [
      {
        title: "Film idea",
        helpText: "",
        fillIn: "FILL IN HERE",
        promptVal: [
          "List 5 ideas for a short film about ",
          ". Include character development and explain why the film is different from the tropes of the genre. Use a style that grabs and holds the attention of readers.",
        ],
        showAfter: (
          <>
            <hr />
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ backgroundColor: "white", fontSize: "large", padding: "10px 15px 15px 15px", borderRadius: "15px", border: "2px solid #f05f40", boxShadow: "0 0 15px rgba(240, 95, 64, 0.6)" }}>
                <h3 style={{ color: "#999", fontWeight: "bold", margin: "0 0 5px 0", fontSize: "12px", fontStyle: "italic" }}>Instructions:</h3>
                <p style={{ margin: "0" }}>
                  Choose the film title you like the most and select{" "}
                  <Button variant="outline-primary" size="sm" onClick={() => handlePromptButtonClicked(null, 1)} style={{ margin: "0 5px", padding: "4px 12px", fontSize: "14px", display: "inline-block", whiteSpace: "nowrap", flexShrink: 0, transition: "all 0.3s ease" }}>
                    2: Script Outline
                  </Button>{" "}
                  to further develop your film.
                  <br /><br />
                  Don't see a title that fits? No problem! Instead adjust the current prompt to help the AI better understand your film and generate the perfect film idea.
                </p>
              </div>
            </div>
            <hr />
          </>
        ),
      },
      {
        title: "Script outline",
        fillIn: "FILL IN YOUR FAVORITE TITLE FROM FILM IDEA",
        promptVal: [
          "Movie title: ",
          "<br>Make a detailed outline for 5 scenes in a short film. Include a list of characters and a list of scenes.",
        ],
        showAfter: (
          <>
            <hr />
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ backgroundColor: "white", fontSize: "large", padding: "10px 15px 15px 15px", borderRadius: "15px", border: "2px solid #f05f40", boxShadow: "0 0 15px rgba(240, 95, 64, 0.6)" }}>
                <h3 style={{ color: "#999", fontWeight: "bold", margin: "0 0 5px 0", fontSize: "12px", fontStyle: "italic" }}>Instructions:</h3>
                <p style={{ margin: "0" }}>
                  AI tools like text generation work best with specific information. Let's start by generating the script for Scene 1. Once that's complete, you can move on to generate the rest of your scenes.
                  <br /><br />
                  Click{" "}
                  <Button variant="outline-primary" size="sm" onClick={() => handlePromptButtonClicked(null, 2)} style={{ margin: "0 5px", padding: "4px 12px", fontSize: "14px", display: "inline-block", whiteSpace: "nowrap", flexShrink: 0, transition: "all 0.3s ease" }}>
                    3: Generate a script
                  </Button>{" "}
                  to begin writing your scene.
                </p>
              </div>
            </div>
            <hr />
          </>
        ),
      },
      {
        title: "Generate a script",
        fillIn: "1",
        promptVal: [
          "Write a complete script for Scene ",
          ".  Include everything needed to film the scene, such as prompts, description of the set, and a complete script with dialogue.",
        ],
        showAfter: (
          <>
            <hr />
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ backgroundColor: "white", fontSize: "large", padding: "10px 15px 15px 15px", borderRadius: "15px", border: "2px solid #f05f40", boxShadow: "0 0 15px rgba(240, 95, 64, 0.6)" }}>
                <h3 style={{ color: "#999", fontWeight: "bold", margin: "0 0 5px 0", fontSize: "12px", fontStyle: "italic" }}>Instructions:</h3>
                <p style={{ margin: "0" }}>
                  Now let's create a character{" "}
                  <Button variant="outline-primary" size="sm" onClick={() => handlePromptButtonClicked(null, 3)} style={{ margin: "0 5px", padding: "4px 12px", fontSize: "14px", display: "inline-block", whiteSpace: "nowrap", flexShrink: 0, transition: "all 0.3s ease" }}>
                    4. Voice Over
                  </Button>{" "}
                  for the movie trailer.
                </p>
              </div>
            </div>
            <hr />
          </>
        ),
      },
      {
        title: "Voice Over",
        fillIn: "",
        promptVal: [
          "Using the scene outline, craft a 50-word, present-tense voice-over monologue for the leading protagonist's movie-trailer intro. Reveal their quirks, introduce the core theme, hint at the stakes, and set the tone. Output only the voice-over text, no stage directions or extra lines.",
        ],
        showAfter: (
          <>
            <hr />
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ backgroundColor: "white", fontSize: "large", padding: "10px 15px 15px 15px", borderRadius: "15px", border: "2px solid #f05f40", boxShadow: "0 0 15px rgba(240, 95, 64, 0.6)" }}>
                <h3 style={{ color: "#999", fontWeight: "bold", margin: "0 0 5px 0", fontSize: "12px", fontStyle: "italic" }}>Instructions:</h3>
                <p style={{ margin: "0" }}>
                  Next, let's create a short description of your film called an{" "}
                  <Button variant="outline-primary" size="sm" onClick={() => handlePromptButtonClicked(null, 4)} style={{ margin: "0 5px", padding: "4px 12px", fontSize: "14px", display: "inline-block", whiteSpace: "nowrap", flexShrink: 0, transition: "all 0.3s ease" }}>
                    5. Elevator Pitch
                  </Button>{" "}
                  . Be prepared to present this text to the class.
                </p>
              </div>
            </div>
            <hr />
          </>
        ),
      },
      {
        title: "Elevator pitch",
        fillIn: "\u00abFILL IN HERE\u00bb",
        promptVal: [
          "Describe a 30 word elevator pitch for the film. Include the climax, rising and falling actions. Write in the style of a film trailer.",
        ],
        showAfter: (
          <>
            <hr />
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ backgroundColor: "white", fontSize: "large", padding: "10px 15px 15px 15px", borderRadius: "15px", border: "2px solid #f05f40", boxShadow: "0 0 15px rgba(240, 95, 64, 0.6)" }}>
                <h3 style={{ color: "#999", fontWeight: "bold", margin: "0 0 5px 0", fontSize: "12px", fontStyle: "italic" }}>Instructions:</h3>
                <p style={{ margin: "0" }}>
                  Your production elements are coming to life. Now, let's generate descriptions for your{" "}
                  <Button variant="outline-primary" size="sm" onClick={() => handlePromptButtonClicked(null, 5)} style={{ margin: "0 5px", padding: "4px 12px", fontSize: "14px", display: "inline-block", whiteSpace: "nowrap", flexShrink: 0, transition: "all 0.3s ease" }}>
                    6. Film Poster
                  </Button>{" "}
                  — these will be used to create images.
                </p>
              </div>
            </div>
            <hr />
          </>
        ),
      },
      {
        title: "Film poster",
        fillIn: "\u00abFILL IN HERE\u00bb",
        promptVal: [
          "Describe a film poster in exquisite detail for this movie. Include the style of the art. Generate 4 options.",
        ],
        showAfter: (
          <>
            <hr />
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ backgroundColor: "white", fontSize: "large", padding: "10px 15px 15px 15px", borderRadius: "15px", border: "2px solid #f05f40", boxShadow: "0 0 15px rgba(240, 95, 64, 0.6)" }}>
                <h3 style={{ color: "#999", fontWeight: "bold", margin: "0 0 5px 0", fontSize: "12px", fontStyle: "italic" }}>Instructions:</h3>
                <p style={{ margin: "0" }}>
                  Now generate your movie poster image!
                  <br /><br />
                  Select one option above and copy/paste in{" "}
                  <Button variant="outline-primary" size="sm" onClick={() => setActiveTab("dalle")} style={{ margin: "0 5px", padding: "4px 12px", fontSize: "14px", display: "inline-block", whiteSpace: "nowrap", flexShrink: 0, transition: "all 0.3s ease", borderColor: "#f05f40", color: "#f05f40" }}>
                    Image Generation
                  </Button>
                </p>
              </div>
            </div>
            <hr />
          </>
        ),
      },
      {
        title: "Marketing materials",
        fillIn: "\u00abFILL IN HERE\u00bb",
        promptVal: ["Make me a list of marketing materials I should create for the film."],
        showAfter: <></>,
      },
      {
        title: "Music",
        fillIn: "1",
        promptVal: ["Describe music for scene ", " in a few sentences.  Be detailed about which instruments and styles are present."],
        showAfter: <></>,
      },
      {
        title: "Production budget",
        fillIn: "\u00abFILL IN HERE\u00bb",
        promptVal: ["I want you to create a complete budget for the filming. Produce that budget step-by-step, include estimated prices, and include links for where I can buy things."],
        showAfter: <></>,
      },
      {
        title: "Convert budget to spreadsheet",
        fillIn: "1",
        promptVal: ["Reproduce that output in a summary form as .csv text. Include the description as another column."],
        showAfter: <></>,
      },
      {
        title: "Insurance",
        fillIn: "It's time for YOU to write your own prompt!  Ask GPT about what insurance you'll need for the film.",
        promptVal: ["", ""],
        showAfter: <></>,
      },
      {
        title: "List of equipment to rent",
        fillIn: "It's time for YOU to write your own prompt!  Ask GPT about what you'll need for the film.",
        promptVal: ["", ""],
        showAfter: <></>,
      },
      {
        title: "Casting call",
        fillIn: "It's time for YOU to write your own prompt!  Ask GPT to help you make a casting call for the film.",
        promptVal: ["", ""],
        showAfter: <></>,
      },
      {
        title: "Day-of shooting schedule",
        fillIn: "It's time for YOU to write your own prompt!  Ask GPT to make a day-of shooting schedule.",
        promptVal: ["", ""],
        showAfter: <></>,
      },
      {
        title: "Social media post",
        fillIn: "It's time for YOU to write your own prompt!  Ask GPT to help you with some social media posts.",
        promptVal: ["", ""],
        showAfter: (
          <>
            <hr />
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <p style={{ backgroundColor: "white", fontSize: "large", padding: "15px", borderRadius: "15px" }}>
                Your film needs a launch website. Let's ask GPT-4 to program a html-only website.
              </p>
            </div>
            <hr />
          </>
        ),
      },
      {
        title: "Website",
        fillIn: "FILL IN",
        promptVal: [
          "Movie Title: ",
          `<br />\n      Description: FILL IN<br />\n      Starring: FILL IN<br />\n      Write a simple HTML landing page website for launching the movie.  Use nice formatting, text colors, and fonts.  Make a spot for us to put the movie poster as a .png, 600 pixels wide.  Also add more content subsections and links to other parts of the website as well as external links (like where can I buy tickets).`,
        ],
        showAfter: (
          <>
            <hr />
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ backgroundColor: "white", fontSize: "large", padding: "15px", borderRadius: "15px" }}>
                <ul>
                  <li>Copy the .html code → paste code into notepad</li>
                  <li>Save notepad on desktop as: MOVIE_TITLE_website.html</li>
                  <li>Double-click on the saved file to view it locally in your browser.</li>
                  <li>You may need to rename your movie poster .png so it can show up in the website.</li>
                  <li>HTML can only render a "static" website. </li>
                  <li>One way to make it dynamic is by adding Javascript, by just asking GPT:</li>
                  <code>Can you add Javascript code so that when you hover over the movie poster, it turns black and white?</code>
                  <li>What other website features can you add?</li>
                </ul>
              </div>
            </div>
            <hr />
          </>
        ),
      },
      {
        title: "Poem",
        fillIn: "",
        promptVal: ["Write a 12-line rhyming poem that summarizes the plot of the film. Add emojis throughout the poem to enhance the storytelling."],
        showAfter: <></>,
      },
    ],
  },

  dalle: {
    instructionTitle: 'This AI tool specializes in generating images from text.',
    instructionSubtitle: 'Paste your film poster description here and select go.',
    placeholder: 'detailed description of your movie poster, generated using GPT4...',
    createPosterButtonText: 'Create a Film Poster from This Image',
    styleButtons: [
      { title: "Abstract", img: "Abstract_Image.jpg", val: "Use an abstract style." },
      { title: "Cartoon", img: "Cartoon_Image.jpg", val: "Use a cartoon style." },
      { title: "Fantasy", img: "Fantasy_Image2.jpg", val: "Use a fantasy style." },
      { title: "Neon", img: "Neon_Image.jpg", val: "Use a neon-image style." },
      { title: "Pencil", img: "Pencil_Image.jpg", val: "Use a black and white pencil-drawing style." },
      { title: "Pop art", img: "Pop_Image.jpg", val: "Use a pop-art style." },
      { title: "Realism", img: "Realism_Image.jpg", val: "Use a hyper-realistic style." },
      { title: "Sci-fi", img: "Sci-fi_Image.jpg", val: "Use a sci-fi style." },
      { title: "Watercolor", img: "Watercolor_Image2.jpg", val: "Use a watercolor style." },
    ],
    modButtons: [
      { title: "Center text", val: "Center the text in the image." },
      { title: "Remove text", val: "Do not include ANY text in the image." },
      { title: "Increase brightness", val: "Make the image brighter and more illuminated." },
      { title: "Decrease brightness", val: "Make the image darker and less illuminated." },
      { title: "Boost saturation", val: "Make the image more vibrant and saturated." },
      { title: "Reduce saturation", val: "Make the image less vibrant and more desaturated." },
      { title: "Increase contrast", val: "Increase the contrast of the image." },
      { title: "Simplify background", val: "Simplify and clean up the background of the image." },
    ],
    templateElements: [
      { id: 'title', text: '<title>', fontSize: 125, fontFamily: 'Oswald', fontWeight: 'bold', fill: '#000000', stroke: '#FFFFFF', strokeWidth: 1, position: 'bottom-title' },
      { id: 'subtitle', text: '<sub-title>', fontSize: 50, fontFamily: 'Oswald', fontWeight: 'bold', fill: '#000000', stroke: '#FFFFFF', strokeWidth: 1, position: 'bottom-subtitle' },
      { id: 'cinemas', text: 'IN CINEMAS 2026', fontSize: 36, fontFamily: 'Oswald', fill: '#000000', stroke: '#FFFFFF', strokeWidth: 1, position: 'bottom-cinemas' },
      { id: 'directed', text: 'directed by: AI', fontSize: 32, fontFamily: 'Oswald', fill: '#000000', stroke: '#FFFFFF', strokeWidth: 1, position: 'bottom-directed' },
      { id: 'name1', text: '<name>', fontSize: 50, fontFamily: 'Oswald', fill: '#000000', stroke: '#FFFFFF', strokeWidth: 1, position: 'top-left' },
      { id: 'name2', text: '<name>', fontSize: 50, fontFamily: 'Oswald', fill: '#000000', stroke: '#FFFFFF', strokeWidth: 1, position: 'top-center' },
      { id: 'name3', text: '<name>', fontSize: 50, fontFamily: 'Oswald', fill: '#000000', stroke: '#FFFFFF', strokeWidth: 1, position: 'top-right' },
    ],
    templateStrings: ['<name>', '<title>', '<sub-title>', 'IN CINEMAS 2026', 'directed by: AI'],
  },

  poster: {
    instructions: 'Add a personal touch to your AI-generated image.',
    instructionsSubtitle: 'Use the editor to include a title, subtitle, release date, and cast.',
    linkedText: 'Film poster linked to presentation',
    formLabels: { names: 'Names:', title: 'Title:', subtitle: 'Subtitle:' },
    formPlaceholders: { name: '<name>', title: '<title>', subtitle: '<sub-title>' },
    nextStepTitle: "Let's now generate voice overs.",
    nextStepButtonText: 'Voice Generation',
  },

  voice: {
    placeholder: 'Enter your elevator pitch here (note: if you create an elevator pitch on the GPT tab, it will appear here automatically)',
    instructionText: 'Bring your film to life with',
    nextStepButtonText: 'Video Generation',
  },

  slideshow: {
    title: 'AI Film Studio - Slideshow',
  },
};
